import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Input from 'components/input/input';
import Select from 'components/select/select';
import CustomerSelect from 'components/select/customer_select';
import DateTimePicker from 'components/date_time_picker/date_time_picker';
import Textarea from 'components/textarea/textarea';
import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';
import {
  NEXT_ACTIONS,
  RECORDING_STATUSES,
  STATUSES,
  MANUAL_PAYMENT_STATUSES,
} from 'config/polysomnography';
import {
  customerShape,
  doctorShape,
  optionShape,
  technicianShape,
} from 'helpers/shared_types';

const ViewComponent = ({
  doctorOptions,
  onChange,
  onCustomerChange,
  onDateChange,
  onDoctorSelect,
  onSelectChange,
  onSubmit,
  onTechnicianSelect,
  polysomnography,
  technicianOptions,
  validation,
  onCustomerSelectChange,
}) => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/polysomnographies">Polysomnographies</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Add
          </h2>
          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              Submit
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Customer</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <CustomerSelect
                  className="customer-select"
                  valid={validation.customer}
                  label="Customer*"
                  value={polysomnography.customer}
                  onChange={onCustomerSelectChange}
                />
              </div>
              <div className="w-100 flex-row items-start justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-33">
                    <Input
                      name="phone"
                      label="Phone"
                      value={polysomnography.customer?.phone}
                      valid={validation.customerPhone}
                      onChange={onCustomerChange}
                    />
                  </div>
                  <div className="w-33">
                    <Input
                      name="email"
                      label="Email"
                      value={polysomnography.customer?.email}
                      valid={validation.customerEmail}
                      onChange={onCustomerChange}
                    />
                  </div>
                  <div className="w-33">
                    <Input
                      name="city"
                      label="City"
                      value={polysomnography.customer?.city}
                      valid={validation.customerCity}
                      onChange={onCustomerChange}
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <Input
                    name="address"
                    label="Address"
                    value={polysomnography.customer?.address}
                    valid={validation.customerAddress}
                    onChange={onCustomerChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Polysomnography</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100 flex justify-between margin-between">
                <div className="w-50">
                  <Select
                    className="technician-select"
                    valid={validation.technician}
                    isMulti={false}
                    label="Technician"
                    value={polysomnography.technician}
                    options={technicianOptions}
                    onChange={onTechnicianSelect}
                  />
                </div>
                <div className="w-50">
                  <Select
                    className="doctor-select"
                    valid={validation.doctor}
                    isMulti={false}
                    label="Doctor*"
                    value={polysomnography.doctor}
                    options={doctorOptions}
                    onChange={onDoctorSelect}
                  />
                </div>
              </div>
              <div className="w-100 flex-row items-start justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <DateTimePicker
                      label="Delivery date"
                      valid={validation.deliveryDate}
                      showTimeInput={true}
                      value={polysomnography.deliveryDate}
                      onChange={(value) =>
                        onDateChange({ field: 'deliveryDate', value })
                      }
                    />
                  </div>
                  <div className="w-50">
                    <DateTimePicker
                      label="Pickup date"
                      valid={validation.pickupDate}
                      showTimeInput={true}
                      value={polysomnography.pickupDate}
                      onChange={(value) =>
                        onDateChange({ field: 'pickupDate', value })
                      }
                    />
                  </div>
                </div>
                <div className="w-100">
                  <Textarea
                    label="Notes"
                    name="notes"
                    valid={true}
                    value={polysomnography.notes}
                    onChange={onChange}
                  />
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-25">
                    <Select
                      className="status-select"
                      valid={validation.polysomnographyStatus}
                      isMulti={false}
                      label="Status"
                      value={polysomnography.status}
                      options={STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('status', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-25">
                    <Select
                      className="recordingStatus-select"
                      valid={validation.recordingStatus}
                      isMulti={false}
                      label="Recording status"
                      value={polysomnography.recordingStatus}
                      options={RECORDING_STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('recordingStatus', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-25">
                    <Select
                      className="nextAction-select"
                      valid={validation.nextAction}
                      isMulti={false}
                      label="Next action"
                      value={polysomnography.nextAction}
                      options={NEXT_ACTIONS}
                      onChange={(selectedOption) =>
                        onSelectChange('nextAction', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-25">
                    <Select
                      className="paymentStatus-select"
                      valid={validation.manualPaymentStatus}
                      isMulti={false}
                      label={'Manual Payment status'}
                      value={polysomnography.manualPaymentStatus}
                      options={MANUAL_PAYMENT_STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('manualPaymentStatus', selectedOption)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

ViewComponent.propTypes = {
  doctorOptions: PropTypes.arrayOf(optionShape),
  onChange: PropTypes.func.isRequired,
  onCustomerChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onDoctorSelect: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onTechnicianSelect: PropTypes.func.isRequired,
  polysomnography: PropTypes.shape({
    nextAction: optionShape,
    manualPaymentStatus: optionShape,
    recordingStatus: optionShape,
    status: optionShape,
    deliveryDate: PropTypes.instanceOf(Date),
    pickupDate: PropTypes.instanceOf(Date),
    technician: technicianShape,
    doctor: doctorShape,
    customer: customerShape,
  }),
  technicianOptions: PropTypes.arrayOf(optionShape),
  validation: PropTypes.shape({
    customer: PropTypes.bool,
    customerPhone: PropTypes.bool,
    customerEmail: PropTypes.bool,
    customerCity: PropTypes.bool,
    customerAddress: PropTypes.bool,
    technician: PropTypes.bool,
    doctor: PropTypes.bool,
    deliveryDate: PropTypes.bool,
    pickupDate: PropTypes.bool,
    polysomnographyStatus: PropTypes.bool,
    recordingStatus: PropTypes.bool,
    nextAction: PropTypes.bool,
    manualPaymentStatus: PropTypes.bool,
  }),
};

export default ViewComponent;
